/*
 * The data table paginations english translation.
 */
export const DATA_TABLE_PAGINATION_EN = {
  rowsPerPage: 'Rows per page',
  page: 'Page',
  of: 'of',
  goToFirstPage: 'Go to first page',
  goToPreviousPage: 'Go to previous page',
  goToNextPage: 'Go to next page',
  goToLastPage: 'Go to last page'
}
/*
 * The data table paginations german translation.
 */
export const DATA_TABLE_PAGINATION_DE = {
  rowsPerPage: 'Einträge pro Seite',
  page: 'Seite',
  of: 'von',
  goToFirstPage: 'Zur ersten Seite',
  goToPreviousPage: 'Zur vorherigen Seite',
  goToNextPage: 'Zur nächsten Seite',
  goToLastPage: 'Zur letzten Seite'
}
